import React from "react";
import FeatureDetails from "./FeatureDetails";

export const FeatureDetailsReadOnly: React.FC<any> = props => (
  <FeatureDetails {...props} readOnly />
);

export default FeatureDetailsReadOnly;
